import React from 'react';
import { Link } from 'react-router-dom'

function Qesq () {
    return (

    <div className="espacio">
        <p class="h1 text-center">QesQ</p>    
        <div class="row container-fluid align-items-center">
            <div class="col-sm-6 espacio">
                <div class="card text-center border-white">
                <div class="card-body">
                    <h5 class="card-title">QesQ</h5>
                    <a target="_blank" href="http://quienesquien.arbal.int/">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/c_scale,w_70/v1611107141/ARBAL/SIAR/WhatsApp_Image_2021-01-19_at_7.45.00_PM.jpg" class="img-thumbnail" alt="..."></img>
                    </a>
                    <p class="card-text"></p>
                </div>
                </div>
            </div>
            <div class="col-sm-6 espacio">
                <div class="card text-center border-white">
                <div class="card-body">
                    <h5 class="card-title">QesQ Móvil</h5>
                    <a target="_blank" href="http://192.168.200.5:90/Account/Login?ReturnUrl=%2F">
                    <img src="https://res.cloudinary.com/ironhackmigu8/image/upload/c_scale,w_70/v1611107054/ARBAL/SIAR/WhatsApp_Image_2021-01-19_at_7.42.35_PM.jpg" class="img-thumbnail" alt="..."></img>
                    </a>
                    <p class="card-text"></p>
                </div>
                </div>
            </div>
        </div>
    </div>
        
    )
}

export default Qesq